import React from 'react'
import { useHistory } from 'react-router-dom'

import { usePayers, INELIGIBLE_INSURANCE_MESSAGE, NO_ACCEPTED_INSURANCE, SignupType } from './utils'
import { BenefitAdministrationType } from '~/utils/constants'
import { secureCache } from '~/utils/secureCache'
import {
  InsurancePayerSelectionUI,
  InsurancePayerOption,
} from '~/components/screens/InsurancePayerSelectionUI'

const AccountInsuranceProvider: React.FC = () => {
  const history = useHistory()
  const { data: payers = [], isLoading: payersLoading } = usePayers(
    BenefitAdministrationType.EXTERNAL,
  )

  const handleSubmit = async (payer: InsurancePayerOption | null) => {
    if (payer) {
      // Save selected payer to cache
      secureCache.set('insurancePayerId', String(payer.id))

      // Set signup type for direct navigation
      secureCache.set('signupType', SignupType.CARE_ONLY_MEMBER)

      // Navigate to name collection
      history.push({ pathname: '/signup/name' })
    } else {
      // Navigate to ineligible insurance page
      history.push({
        pathname: '/signup/insurance/ineligible',
        state: {
          title: INELIGIBLE_INSURANCE_MESSAGE[NO_ACCEPTED_INSURANCE]['title'],
          body: INELIGIBLE_INSURANCE_MESSAGE[NO_ACCEPTED_INSURANCE]['body'],
        },
      })
    }
  }

  return (
    <InsurancePayerSelectionUI payers={payers} isLoading={payersLoading} onSubmit={handleSubmit} />
  )
}

export default AccountInsuranceProvider
